import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import FileIcon, {
  getExtAttributes,
} from '../../../../../../../commonComponents/icons/FileIcon';
import { addAlphaToHex } from '../../../../../../../services/utilityFunctions';
import InboxMessageProp from '../../../../../propTypes/inboxMessageProp';
import InboxContainer from '../InboxContainer';

export default function DriveMessage({ message }) {
  const { createdAt, file } = message;

  const handleClick = useCallback(() => {
    if (!file?.url) return;
    window.open(file.url, '_blank');
  }, [file?.url]);

  let ext =
    file?.ext ||
    file?.originalName?.split('.')?.pop() ||
    file?.name?.split('.')?.pop();

  let { color } = getExtAttributes(ext);

  if (file.source === 'url') {
    ext = 'link';
    color = '#2563EB';
  }

  return (
    <InboxContainer
      style={{
        '--news-item-bg': addAlphaToHex(color, 0.1),
        '--news-item-title': '#6F6C80',
        '--news-item-text': '#6F6C80',
      }}
      title=" "
      image={ext ? () => <FileIcon ext={ext} /> : undefined}
      createdAt={createdAt}
      onClick={file?.url ? handleClick : undefined}
    >
      <div className="news-item-drive-description">
        {file?.originalName || file?.name || ''}
      </div>
    </InboxContainer>
  );
}

DriveMessage.propTypes = {
  message: PropTypes.shape(InboxMessageProp.propType).isRequired,
};
